import { NgClass, NgFor, NgIf } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { EM310List } from '../../shared/constants/em310.constant';

@Component({
  selector: 'app-EM310',
  standalone: true,
  imports: [NgFor, NgIf, NgClass, HttpClientModule, OverlayPanelModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './EM310.component.html'
})
export class EM310Component {

  @Input()
  public slug!: string;

  public showInfo: boolean = false;

  public em310List: any[] = EM310List;
  public sensorList: any[] = [];
  public location: any = null;
  
  private _sensorContainerDistance = 10;

  private _subscription: Subscription = new Subscription();

  constructor(private _route: ActivatedRoute,
              private _cdr: ChangeDetectorRef,
              private _http: HttpClient) {
  }

  async ngOnInit() {
    await this._getAllData();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public getPercetage(distance: number) {
    const baseHeight = 50;
    const realDistance = (baseHeight + this._sensorContainerDistance) - Math.round(distance);
    const height = Math.ceil((realDistance / baseHeight) * 10);
    const percentage = Math.round((realDistance / baseHeight) * 100);

    const maxHeight = 10; // 10rem
    const calculatedHeight = (percentage / 100) * maxHeight;
    let percentageNumber: any = 0;

    if ((Math.floor(calculatedHeight * 10) > 0) && (Math.floor(calculatedHeight * 10) <= 100)) {
      percentageNumber = Math.floor(calculatedHeight * 10)
    }
    
    if (Math.floor(calculatedHeight * 10) > 100) {
      percentageNumber = 100;
    }

    if (Math.floor(calculatedHeight * 10) < 0) {
      percentageNumber = 0;
    }
    
    return [height, percentageNumber, this._getColor(percentage)];
  }

  public toggleInformation(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const iconClicked = target.classList.contains('pi-info-circle');

    if (iconClicked) {
      this.showInfo = !this.showInfo;
    } else {
      if (this.showInfo) {
        this.showInfo = false;
      }
    }

    this._cdr.detectChanges();
  }

  private _getColor(percentage: number): string {
    let color = '';

    if (percentage >= 85) {
      color = 'red';
    } else if (percentage >= 50) {
      color = 'yellow';
    } else {
      color = 'green';
    }

    return color;
  }

  private async _getAllData(): Promise<any> {
    this._verifyLocalStorage();
    this._http.post<any>('https://iot-core.cochabamba.bo/api/token', {
      username: 'smartCityAdmin',
      password: 'sm@rtC!ty--1!'
    }).subscribe(
      (response: any) => {
        const data = response;
        
        const url_em310 = `wss://iot-core.cochabamba.bo/ws/socket-server/em310/?token=${data.access}`;
        const EM310ConsumerSocket = new WebSocket(url_em310);

        EM310ConsumerSocket.onmessage = (e) => {
          console.log("SENSORES EM310");
          const data = JSON.parse(e.data);
          
          if (data) {
            this._updateSensorData(data);
            console.log(data);
          }
        };

        EM310ConsumerSocket.onclose = (e) => {
          console.log("Conexion cerrada");
        };
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  private _verifyLocalStorage() {
    for (let i = 0; i < this.sensorList.length; i++) {
      if (localStorage.getItem(this.sensorList[i].devEUI)) {
        this.sensorList[i].payload = {};
        this.sensorList[i].payload.Distance = Number(localStorage.getItem(this.sensorList[i].devEUI));
      }
    }
  }

  private _updateSensorData(data: any): void {
    const index = this.sensorList.findIndex((sensor: any) => sensor.devEUI === data.data?.DevEUI);

    if (index !== -1) {
      this.sensorList[index].payload = data.data?.PayloadData;
      localStorage.setItem(this.sensorList[index].devEUI, this.sensorList[index].payload.Distance);
    }
    
    this._cdr.detectChanges();
  }
}
